import { z } from 'zod'; // Add new import

export const FinancialReportSchema = z
  .object({
    resourceId: z.number().nullable().optional(),
    orderId: z.number().nullable().optional(),
    jobId: z.number().nullable().optional(),
    customerId: z.number().nullable().optional(),
    startMonth: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
    endMonth: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
    year: z.number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    }),
  })
  .refine((data) => data.startMonth <= data.endMonth, {
    message: 'endDateLessThanStartDate',
    path: ['endMonth'],
  });
